<template>
    <div class=" m-4" >

      <div v-if="isMerchant" class="row">
        <div class="col-sm-12 col-md-6 offset-md-3">
          <h5 class="ms-3 me-3 mb-0 text-center text-capitalize-first">{{ helper.trans("labels.secret_key")}}</h5>
        </div>
        <div class="col-sm-12 col-md-6 offset-md-3">
          <div class="card card-body">
            <div class="invoice-input-group mb-0">
              <div class="input-group">
                <input type="text" class="form-control invoice-input font-monospace" :value="user?.secret" readonly>
                <copy-button class="btn btn-copy" :value="user?.secret"></copy-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12 col-md-6 offset-md-3">
          <h5 class="ms-3 me-3 mb-0 text-center text-capitalize-first">{{ helper.trans("labels.2fa")}}</h5>
        </div>
        <div class="col-sm-12 col-md-6 offset-md-3">
          <div class="card card-body">
            <LoaderWrapper ref="twoFactorAuthLoader">
              <div class="row">
                <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.status")}}:</label>
                <div class="col-sm-8">
                  <span v-if="user?.is2faEnabled" class="text-success">{{ helper.trans('labels.enabled')}}</span>
                  <span v-if="!user?.is2faEnabled" class="text-warning"><i class="fa fa-warning"></i> {{ helper.trans('labels.disabled')}}</span>
                  <button v-if="!user?.is2faEnabled" type="button" class="btn btn-primary btn-sm ms-2 text-capitalize-first" @click.prevent="enable2fa()">{{ helper.trans("labels.enable")}}</button>
                  <button v-if="user?.is2faEnabled" type="button" class="btn btn-danger ms-2 btn-sm text-capitalize-first" @click.prevent="disable2fa()">{{ helper.trans("labels.disable")}}</button>
                </div>
              </div>
            </LoaderWrapper>
          </div>
        </div>
        <b-modal :title="helper.trans('labels.2fa')"
                 :modelValue="twoFactorQrCodeModalData !== null"
                 footer-class="d-flex justify-content-end"
                 @update:modelValue="$event === false && (twoFactorQrCodeModalData = null)">
          <template #default>
            <div>
              {{ helper.trans('labels.2fa_step_1') }}
            </div>
            <div class="d-flex justify-content-center">
              <vue-qrcode v-if="twoFactorQrCodeModalData" :value="twoFactorQrCodeModalData.qr" tag="svg" class="w-100" :options="{ width: '100%' }"></vue-qrcode>
            </div>
            <div class="d-flex justify-content-center mb-3">
              <div class="input-group input-group-sm">
                <input type="text" class="form-control form-control-sm font-monospace" :value="twoFactorQrCodeModalData?.secret" readonly>
                <copy-button class="btn btn-copy" :value="twoFactorQrCodeModalData?.secret"></copy-button>
              </div>
            </div>
            <div>
              {{ helper.trans('labels.2fa_step_2') }}
            </div>
            <div class="d-flex justify-content-center flex-column mt-2" v-if="twoFactorQrCodeModalData">
              <div class="input-group">
                <FormInputWrapper v-slot="parentProps"  :errors="helper.getErrors('2fa', `code`)" class="w-100">
                  <input type="text"
                         v-maska
                         data-maska="999 999"
                         data-maska-tokens="9:[0-9]"
                         :class="parentProps.class" class="form-control form-control-lg" v-model="twoFactorQrCodeModalData.code" :placeholder="helper.trans('labels.2fa_enter_code')">
                </FormInputWrapper>

              </div>
              <button type="button" @click.prevent="enable2faConfirm()" class="btn btn-sm btn-primary text-capitalize-first mt-2">
                {{ helper.trans('labels.2fa_verify')  }}
              </button>
            </div>

          </template>
          <template #footer>
            <button type="button" @click="twoFactorQrCodeModalData = null" class="btn btn-outline-dark btn-sm text-capitalize-first">
              {{ helper.trans('button.cancel')  }}
            </button>
          </template>
        </b-modal>
      </div>

      <div v-if="isTrader || isOperator || isAdmin" class="row">
        <div class="col-sm-12 col-md-6 offset-md-3">
          <h5 class="ms-3 me-3 mb-0 text-center text-capitalize-first">{{ helper.trans("labels.telegram")}}</h5>
        </div>
        <div class="col-sm-12 col-md-6 offset-md-3">
          <LoaderWrapper ref="telegramLoader">
          <div class="card card-body">
            <div class="row">
              <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.telegram_bot_notifications")}}:</label>
              <div class="col-sm-8">
                <span v-if="telegramMe === null"></span>
                <span v-else-if="telegramMe?.id === null" class="text-warning"><i class="fa fa-warning"></i> {{ helper.trans("labels.telegram_bot_not_linked")}}</span>
                <span v-else class="text-primary">@{{ telegramMe?.username }}</span>

                <button v-if="telegramMe && telegramMe?.id === null" type="button" class="btn btn-sm btn-primary ms-2" @click.prevent="createTgInviteRequest()"><i class="fa-brands fa-telegram"></i> {{ helper.trans("labels.telegram_link_account")}}</button>
                <button v-if="telegramMe && telegramMe?.id" type="button" @click.prevent="unlinkTgAccount()" class="btn btn-sm btn-danger ms-2"><i class="fa fa-times"></i> {{ helper.trans("labels.telegram_unlink_account")}}</button>
                <a v-if="telegramMe && telegramMe?.id === null && tgBotNotificationsUrl !== null" :href="tgBotNotificationsUrl" target="_blank" class="d-flex">{{ helper.trans('labels.tg_click_on_link')}}</a>
                <a ref="tgBotNotificationsLink" href="" target="_blank" style="display: none"></a>
              </div>
            </div>
            <div class="row" v-if="isTrader && telegramMe?.id">
              <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.telegram_bot_notifications_settings")}}:</label>
            </div>
            <div class="row" v-if="isTrader && telegramMe?.id">
              <div class="offset-sm-4 col-sm-8" v-for="notification in Object.values(TgNotification)">
                <div class="form-check small mb-0">
                  <input class="form-check-input" :value="notification" v-model="enabledNotifications" type="checkbox" :id="notification" :disabled="notification === TgNotification.NOTIFICATION_WEEKLY_REPORT && !user?.tgChatGroupId">
                  <label class="form-check-label" :for="notification">
                    {{ helper.trans(`tg_notifications.${notification}`)}}
                  </label>
                </div>
                <div v-if="notification === TgNotification.NOTIFICATION_WEEKLY_REPORT && !user?.tgChatGroupId" class="text-muted small">
                  {{ helper.trans('labels.weekly_report_tg_group_hint') }}
                </div>
              </div>
              <div class="offset-sm-4 col-sm-8">
                <button type="button" @click="saveNotifications" class="btn btn-outline-success btn-sm text-capitalize-first">
                  {{ helper.trans('button.save')  }}
                </button>
              </div>
            </div>
          </div>
          </LoaderWrapper>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12 col-md-6 offset-md-3">
          <h5 class="ms-3 me-3 mb-0 text-center">{{ helper.trans("labels.profile")}}</h5>
        </div>
        <div class="col-sm-12 col-md-6 offset-md-3">
          <div class="card">
            <LoaderWrapper ref="passwordLoader">
              <div class="card-body">

                <div class="mb-3 row">
                  <label for="timezone" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.timezone")}}:</label>
                  <div class="col-sm-4">
                    <form name="timezone-select" autocomplete="off">
                    <Multiselect
                      class="multiselect-sm"
                      name="timezone"
                      id="timezone"
                      :options="moment.tz.names()"
                      v-model="timezone"
                      select-label="Select"
                      open-direction="bottom"
                      autocomplete="timezone"
                      :multiple="false"
                      :searchable="true"
                      :internal-search="true"
                      :clear-on-select="false"
                      :close-on-select="true"
                      :options-limit="100"
                      :limit="1000"
                      :show-no-results="false"
                      :hide-selected="false"
                    >
                    </Multiselect>
                    </form>
                  </div>
                </div>

                <div class="mb-3 row">
                  <label for="lang" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.lang")}}:</label>
                  <div class="col-sm-4">
                    <form name="lang-select" autocomplete="off">
                      <Multiselect
                        class="multiselect-sm"
                        name="lang"
                        id="lang"
                        :options="['ru', 'en']"
                        v-model="lang"
                        select-label="Select"
                        open-direction="bottom"
                        autocomplete="lang"
                        :multiple="false"
                        :searchable="true"
                        :internal-search="true"
                        :clear-on-select="false"
                        :close-on-select="true"
                        :options-limit="100"
                        :limit="1000"
                        :show-no-results="false"
                        :hide-selected="false"
                      >
                      </Multiselect>
                    </form>
                  </div>
                </div>

                <div class="mb-1 row">
                  <label for="inputPassword" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.new_password")}}:</label>
                  <div class="col-sm-4">
                    <form name="change-pwd-new" autocomplete="off">
                    <input v-model="password" type="password" autocomplete="off" name="pwd-new" class="form-control form-control-sm" id="inputPassword">
                    </form>
                  </div>
                </div>

                <div class="mb-3 row">
                  <label for="inputPasswordConf" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.confirm_password")}}:</label>
                  <div class="col-sm-4">
                    <form name="change-pwd-new-repeat" autocomplete="off">
                    <input v-model="passwordConfirm" type="password" autocomplete="off" name="pwd-new-repeat" class="form-control form-control-sm" id="inputPasswordConf">
                    </form>
                  </div>
                </div>

                <div class="mb-1 row">
                  <div class="col-sm-8 text-end">
                    <button type="button" @click.prevent="updateProfile()" class="btn btn-sm btn-primary text-capitalize-first">{{ helper.trans("labels.save_changes")}}</button>
                  </div>

                </div>

              </div>
            </LoaderWrapper>
          </div>
        </div>
      </div>

    </div>
</template>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {defineComponent, onMounted, toRefs, reactive, ref, ComputedRef, computed} from 'vue'
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import {helper} from "@/service/CommonHelper";
import APIClient from "@/service/APIClient";
import {useStore} from "vuex";
import moment from "moment/moment";
import {useNotification} from "@kyvg/vue3-notification";
import ApiKeyDTO from "@/models/ApiKeyDTO";
import CopyButton from "@/components/CopyButton.vue";
import TelegramMeDTO from "@/models/TelegramMeDTO";
import UserDTO from "@/models/UserDTO";
import TraderDTO from "@/models/TraderDTO";
import MerchantDTO from "@/models/MerchantDTO";
import {BModal} from "bootstrap-vue-3";
import TwoFactorAuthEnableResponseDTO from "@/models/TwoFactorAuthEnableResponseDTO";
import FormInputWrapper from "@/components/FormInputWrapper.vue";
import {TgNotification} from "@/models/enum/TgNotification";
import Multiselect from "vue-multiselect";


const api = new APIClient();
const notification = useNotification()

export default defineComponent({
  name: 'Settings',
  components: {
    FormInputWrapper,
    BModal,
    LoaderWrapper,
    CopyButton,
    Multiselect
  },
  setup() {
    const store = useStore()

    const passwordLoader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const telegramLoader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const twoFactorAuthLoader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const tgBotNotificationsLink = ref<InstanceType<any>>(null)

    const state = reactive({
      enabledNotifications: Object.values(TgNotification) as TgNotification[],
      password: null as string|null,
      timezone: store.getters.getUser?.timezone,
      lang: store.getters.getUser?.lang ?? window.userLang,
      passwordConfirm: null as string|null,
      apiKeys: [] as ApiKeyDTO[],
      telegramMe: null as TelegramMeDTO|null,
      twoFactorQrCodeModalData: null as TwoFactorAuthEnableResponseDTO|null,
      tgBotNotificationsUrl: null as string|null,
    });

    const getTelegramMe = async () => {
      try {
        telegramLoader.value?.show()
        state.telegramMe = await api.getTgMe();
        const disabledNotifications = state.telegramMe?.disabledNotifications ?? []
        state.enabledNotifications = state.enabledNotifications.filter((item) => !disabledNotifications.includes(item))
      } finally {
        telegramLoader.value?.hide()
      }
    }

    const saveNotifications = async () => {
      try {
        telegramLoader.value?.show()
        await api.updateTgNotifications({disabledNotifications: Object.values(TgNotification).filter((item: TgNotification) => !state.enabledNotifications.includes(item))});
        await getTelegramMe();
      } finally {
        telegramLoader.value?.hide()
      }
    }

    const unlinkTgAccount = async () => {
      try {
        telegramLoader.value?.show()
        await api.deleteTgMe();
        await getTelegramMe();
      } finally {
        telegramLoader.value?.hide()
      }
    }

    const createTgInviteRequest = async () => {
      try {
        state.tgBotNotificationsUrl = null;
        telegramLoader.value?.show()
        const result = await api.createTgInviteRequest();
        state.tgBotNotificationsUrl = result.startUrl;
        tgBotNotificationsLink.value!.href = result.startUrl;
        tgBotNotificationsLink.value!.click()
      } finally {
        telegramLoader.value?.hide()
      }
    }

    const enable2faConfirm = async () => {
      try {
        await api.twoFactorAuthEnableConfirm({
          ...state.twoFactorQrCodeModalData!,
          code: state.twoFactorQrCodeModalData?.code?.replace(' ', '')
        } as TwoFactorAuthEnableResponseDTO);
        state.twoFactorQrCodeModalData = null;
        await store.dispatch('loadUser');
      } catch (e) {
        helper.handleErrors('2fa', e)
      } finally {
      }
    }

    const disable2fa = async () => {
      try {
        twoFactorAuthLoader.value?.show()
        await api.twoFactorAuthDisable();
        await store.dispatch('loadUser');
      } finally {
        twoFactorAuthLoader.value?.hide()
      }
    }

    const enable2fa = async () => {
      try {
        twoFactorAuthLoader.value?.show()
        state.twoFactorQrCodeModalData = await api.twoFactorAuthEnable();
      } finally {
        twoFactorAuthLoader.value?.hide()
      }
    }

    const updateProfile = async () => {
      if (state.password && state.password !== state.passwordConfirm) {
        notification.notify({
          title: helper.trans('password_change.error.mismatch'),
          type: 'error'
        });

        return;
      }

      if (state.password && state.password.length < 5) {
        notification.notify({
          title: helper.trans('password_change.error.min_length', {length: 5}),
          type: 'error'
        });

        return;
      }


      passwordLoader.value?.show();
      try {
        await api.updateProfile({
          plainPassword: !state.password ? null : state.password,
          timezone: state.timezone,
          lang: state.lang,
          refreshToken: store.getters.getAuth?.refreshToken
        });

        notification.notify({title: helper.trans('profile.success')});
        await store.dispatch('loadUser')
        state.password = null;
        state.passwordConfirm = null;

      } catch (e) {
        notification.notify({
          title: helper.trans('profile.failed'),
          type: 'error'
        });
      } finally {
        passwordLoader.value?.hide();
      }

    }

    onMounted(() => {
      getTelegramMe();
      document.addEventListener('visibilitychange', async function (event) {
        state.telegramMe = await api.getTgMe();
      });
    });

    return {
      ...toRefs(state),
      updateProfile,
      passwordLoader,
      telegramLoader,
      dateHelper,
      numberFormatter,
      moment,
      helper,
      user: computed<TraderDTO | MerchantDTO | UserDTO | null>(() => store.getters.getUser),
      isMerchant: computed<boolean>(() => store.getters.isMerchant),
      isTrader: computed<boolean>(() => store.getters.isTrader),
      isOperator: computed<boolean>(() => store.getters.isOperator),
      isAdmin: computed<boolean>(() => store.getters.isAdmin),
      enable2fa,
      createTgInviteRequest,
      tgBotNotificationsLink,
      twoFactorAuthLoader,
      enable2faConfirm,
      disable2fa,
      unlinkTgAccount,
      saveNotifications,
      TgNotification
    }
  }
})
</script>
